import type { FC, PropsWithChildren } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const GoogleReCaptchaProviderComponent: FC<
  PropsWithChildren<{
    recaptchaSiteKey: string | undefined;
  }>
> = ({ recaptchaSiteKey, children }) => {
  if (!recaptchaSiteKey) {
    return children;
  }
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: false,
        defer: true,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};
